export const SEARCH_FILES = "SEARCH_FILES"